<template>
  <button @click.stop.prevent="$emit(`${buttonName}-button`)">
    <font-awesome-icon
      :icon="iconName"
      class="icon"
      :style="styles"
    />
  </button>
</template>

<script>
import { computed } from 'vue';

import colors from '../../assets/css/colors.scss';

export default {
  name: 'CustomIconButton',
  props: {
    buttonName: String,
    color: String,
    iconName: String,
  },
  setup(props) {
    const styles = computed(() => ({
      color: props.color ? props.color : colors.grey,
    }));

    return {
      styles,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

button {
  align-items: center;
  background-color: inherit;
  border: inherit;
  cursor: pointer;
  display: flex;
  font-size: inherit;
  height: inherit;
  justify-content: center;
  transition: ease-out 0.1s;
  width: inherit;
}

.icon {
  height: 100%;
  width: 100%;
}

</style>
